import { Language } from "../types";

export function getLocalizedText(
  ruText: string,
  enText?: string,
  language: Language = "ru"
): string {
  if (language === "en") {
    // If English is selected, use English text if available, otherwise fallback to Russian
    return enText && enText.trim() !== "" ? enText : ruText;
  }
  return ruText;
}

export function formatTime(date: Date): string {
  return date.toLocaleTimeString("ru-RU", {
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function formatDate(date: Date): string {
  return date.toLocaleDateString("ru-RU", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}

export function formatDateTime(date: Date): { time: string; date: string } {
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear();
  const dateStr = `${day}.${month}.${year}`;
  return {
    time: formatTime(date),
    date: dateStr,
  };
}

export const translations = {
  ru: {
    welcome: "Добро пожаловать",
    search: "Поиск",
    map: "Карта ТРЦ",
    categories: "Категории",
    events: "События",
    myLocation: "Мое местоположение",
    buildRoute: "Построить маршрут",
    moreDetails: "Подробнее",
    back: "Назад",
    workingHours: "Время работы",
    floor: "Этаж",
    location: "Расположение",
    searchResults: "Результаты поиска",
    noResults: "Ничего не найдено",
    loading: "Загрузка...",
    error: "Ошибка",
    retry: "Повторить",
    close: "Закрыть",
    next: "Далее",
    previous: "Назад",
    developedBy: "Разработано компанией TEHNOSKY",
    developedByCompany: "Разработано компанией",
    accessibility: "Для людей с ограниченными возможностями",
    language: "Язык",
    russian: "Русский",
    english: "English",
  },
  en: {
    welcome: "Welcome",
    search: "Search",
    map: "Mall Map",
    categories: "Categories",
    events: "Events",
    myLocation: "My Location",
    buildRoute: "Build Route",
    moreDetails: "More Details",
    back: "Back",
    workingHours: "Working Hours",
    floor: "Floor",
    location: "Location",
    searchResults: "Search Results",
    noResults: "No results found",
    loading: "Loading...",
    error: "Error",
    retry: "Retry",
    close: "Close",
    next: "Next",
    previous: "Previous",
    developedBy: "Developed by TEHNOSKY",
    developedByCompany: "Developed by",
    accessibility: "For people with disabilities",
    language: "Language",
    russian: "Русский",
    english: "English",
  },
};

export function t(
  key: keyof typeof translations.ru,
  language: Language = "ru"
): string {
  return translations[language][key] || translations.ru[key];
}
